import React, { useState, useMemo } from 'react';
import { Select } from '@naf/input';
import styled from '@emotion/styled';
import { Text, TextVariant } from '@naf/text';
import { useExternalFetch } from '../../hooks/useExternalFetch';

type Props = {
  url: string;
  searchParams?: { [k: string]: string };
  dataMap: (data: any) => { label: string; value: string }[];
  handleSelect: (item: any) => void;
  error?: boolean;
  placeholder?: string;
  label?: string;
  value?: string;
  disabled?: boolean;
  onChange: (val: string) => void;
  autoComplete?: string;
};

const ExternalTypeahead = ({
  url,
  dataMap,
  onChange,
  handleSelect,
  error = false,
  placeholder,
  label,
  value,
  searchParams,
  disabled,
  autoComplete,
}: Props) => {
  const [params, setSearchParams] = useState({ ...searchParams });
  const selectedValue = useMemo(() => (value ? { label: value, value } : undefined), [value]);
  const skip = !params.sok || params.sok.length < 3;

  const {
    data,
    isLoading,
    error: dataError,
  } = useExternalFetch({
    url,
    searchParams: params,
    skip,
  });

  const setOptions = () => {
    if (!data || skip) return [];
    if (data.adresser.length === 0) {
      return [{ label: 'Ingen treff', value: '', disabled: true }];
    }
    return dataMap(data);
  };

  return (
    <>
      <StyledSelect
        label={label}
        options={setOptions()}
        selected={selectedValue || undefined}
        handleSelect={(dataObject: any) => dataObject?.value && handleSelect(dataObject)}
        width="100%"
        error={error}
        placeholder={placeholder}
        maxLines={6}
        value={value}
        autoComplete={autoComplete}
        filterFunction={(inputValue) => {
          if (inputValue !== value) onChange(inputValue || undefined);
          setSearchParams({ ...searchParams, sok: inputValue });
        }}
        disabled={disabled}
      />
      {!isLoading && dataError && (
        <Text variant={TextVariant.ArticleTextHeader}>
          Oops, vi har problemer med motoren... Ta kontakt med kundesenteret hvis problemet fortsetter!
        </Text>
      )}
    </>
  );
};

const StyledSelect = styled(Select)`
  width: 100%;
`;

export default ExternalTypeahead;
